import {
  SET_CANONICAL_NODES,
  SET_VIS_TO_WVR_MAP,
  SET_GRAPH_ADDING_EDGE,
  SET_GRAPH_COLOR_PICKER_PROPS,
  SET_GRAPH_CREATING_EDGE,
  SET_GRAPH_RENAME_RELATION_PROPS,
  SET_SHOW_ATTRIBUTES,
  SET_SHOW_RELEVANT_META_NODES,
  SET_SHOW_ALL_META_NODES,
  SET_QUERY_RESULTS,
  SET_RICH_NODE_MAP
} from './actionTypes'

export const reducer = (state, { type, payload }) => {
  try {
    switch (type) {
      case SET_CANONICAL_NODES:
        return { ...state, canonicalNodeIds: payload.data }
      case SET_VIS_TO_WVR_MAP:
        return { ...state, visToWvrMap: payload.data }
      case SET_GRAPH_ADDING_EDGE:
        return { ...state, isAddingEdge: payload.data }
      case SET_GRAPH_COLOR_PICKER_PROPS:
        return { ...state, colorPickerProps: payload.data }
      case SET_GRAPH_CREATING_EDGE:
        return { ...state, creatingEdgeProps: payload.data }
      case SET_GRAPH_RENAME_RELATION_PROPS:
        return { ...state, renameRelationProps: payload.data }
      case SET_SHOW_ATTRIBUTES:
        return { ...state, showAttributes: payload.data }
      case SET_SHOW_RELEVANT_META_NODES:
        return { ...state, showRelevantMetaNodes: payload.data }
      case SET_SHOW_ALL_META_NODES:
        return { ...state, showAllMetaNodes: payload.data }
      case SET_QUERY_RESULTS:
        return { ...state, queryResults: payload.data }
      case SET_RICH_NODE_MAP:
        return { ...state, richNodesMap: payload.data }
      default:
        throw new Error(`GraphContext reducer recieved an invalid action type (${ type }).`)
    }
  } catch (e) {
    console.error(e)
  }
}
